export class DeviceType {
    id: number;
    code: string;
    name: string;
    state: any;
}